import { bootstrapApplication } from '@angular/platform-browser';
import { ModuleRegistry } from 'ag-grid-community';
import { AllEnterpriseModule, LicenseManager } from 'ag-grid-enterprise';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { environment } from './environments/environment';
import { captureInstallEvents } from './app/core/install-prompt-source';

// AG Grid v33+ requires explicit module registration; without it the grid
// renders no rows even when rowData is supplied. Apply the Enterprise license
// and register all (community + enterprise) features once, before bootstrap.
if (environment.agGridLicenseKey) {
  LicenseManager.setLicenseKey(environment.agGridLicenseKey);
}
ModuleRegistry.registerModules([AllEnterpriseModule]);

// Capture the install prompt before bootstrap — Chrome can fire it before Angular is ready.
captureInstallEvents();

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
